module.exports = __webpack_public_path__ + "static/media/logoLightItesa.eeec5418.svg";